import { render, staticRenderFns } from "./projects-grid.vue?vue&type=template&id=651cdfe0&"
import script from "./projects-grid.vue?vue&type=script&lang=js&"
export * from "./projects-grid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports